module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [(_vm.commonQuestionList && _vm.commonQuestionList.length > 0) ? _c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "title_wapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("常见问题")]), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.showMore('/document')
      }
    }
  }, [_vm._v("\n        查看更多\n        "), _c('img', {
    staticClass: "more_icon",
    attrs: {
      "src": require("../../assets/images/client/more.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "line"
  }), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.commonQuestionList), function(item) {
    return _c('li', {
      key: item._id,
      staticClass: "item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'QuestionDetail',
          query: {
            id: item._id,
            type: 'quesion'
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.remark ? '• ' + item.remark : '') + "\n        ")])], 1)
  }))]) : _vm._e(), (_vm.dynamicList && _vm.dynamicList.length > 0) ? _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "title_wapper product_wapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品动态")]), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.showMore('/dynamics')
      }
    }
  }, [_vm._v("\n        查看更多\n        "), _c('img', {
    staticClass: "more_icon",
    attrs: {
      "src": require("../../assets/images/client/more.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "multipleTable",
    staticClass: "v2table",
    attrs: {
      "data": _vm.dynamicList,
      "tooltip-effect": "dark",
      "border": "",
      "width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80",
      "label": "序号"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "production",
      "label": "产品",
      "width": "150"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "htmlText",
      "label": "更新摘要"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "displayTime",
      "label": "更新日期",
      "width": "150"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "详情",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-blue",
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.handleDetail(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1)]) : _vm._e(), (_vm.productList && _vm.productList.length > 0) ? _c('div', {
    staticClass: "document"
  }, [_c('div', {
    staticClass: "title_wapper question_wapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品文档")]), _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.showMore('/document')
      }
    }
  }, [_vm._v("\n        查看更多\n        "), _c('img', {
    staticClass: "more_icon",
    attrs: {
      "src": require("../../assets/images/client/more.png"),
      "alt": ""
    }
  })])]), _c('ul', {
    staticClass: "question_ul"
  }, _vm._l((_vm.productList), function(item) {
    return _c('li', {
      key: item._id,
      on: {
        "click": function($event) {
          _vm.handleJump(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3201f068!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/Index.vue
// module id = 403
// module chunks = 0